// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';

	function debounce(method, delay) {
		clearTimeout(method._timeoutId);
		method._timeoutId= setTimeout(function(){
			method();
		}, delay);
	}
	
	// Focus input if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( this ).find( 'input' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );
	
	// Change form to have 5 rows
	$( '#contact-form [name=contact-message]').attr('rows', '5');

	const mobileWidth = window.innerWidth < 720;
	
	// Make nav-links close the menu
	if (mobileWidth) {
		$('.nav-link[title="Home"]').addClass('active-link');
		
		const clearActiveNavLink = () => $('.nav-link.active-link').removeClass('active-link');
		const navLinks = $('.nav-link');
		navLinks.each((i, el) => {
			el.addEventListener('click', () => {
				// Trigger closing of nav
				$('.navbar-toggler').trigger('click')
				
				// If mobile show active nav link
				clearActiveNavLink();
				$(el).addClass('active-link');
			})
		})
		const $sections = $('section');
		// Set hash when section scrolls in
		window.addEventListener('scroll', function() {
			debounce(() => {
				const $window = $(window); 
				// 65 is header height
				const windowScrollTop = $window.scrollTop() + 65;
				// when element is 1/4 of the window height away from top , switch active link
				const windowBottom = windowScrollTop + ( $window.height() / 4);
				
				$sections.each((i, el) => {
					const $el = $(el); 
					const elTop = $el.offset().top;
					const elBottom = elTop + $el.outerHeight();
				
					// Using contain (*) without first letter instead of capitalizing first letter
					const navLink = $(`.nav-link[title*="${el.id.slice(1)}"]`)
					
					// If navlink value doesn't exist from jquery
					if (navLink.length  === 0) return;
					
					
					if (el.id === 'contact'){
						console.log('elBottom > windowScrollTop', [elBottom, windowScrollTop])
						console.log('elTop < windowBottom', [elTop, windowBottom])
					}
					
					
					if (elBottom > windowScrollTop && elTop < windowBottom ){
						// Lower Section With be Prioritized
						clearActiveNavLink();
						navLink.addClass('active-link');
					}
				});
				
			}, 200);
		})
	}
	
	
	// Add socials to navbar
	if ($('#navbar .socials').length === 0 && mobileWidth) {
		// clone & adjust the classes then append
		$('footer .socials').clone()
		.removeClass('justify-content-center col-4 col-md-4')
		.addClass('ml-n3')
		.appendTo('#navbar');
		
		// Set to d-none while menu closed
		$('#navbar .socials').toggleClass('d-flex d-none');
	}
	
	
	// Prevent scrolling when menu in open
	$('.navbar-toggler').on('click', function() {

		$('body').toggleClass('noscroll-body');
		$('#navbar').toggleClass('container');
		
		if (mobileWidth) {
			$('#navbar .socials').toggleClass('d-flex d-none');
		}

	});
	
	
	
	
}( jQuery ) );
